import { createTranslations } from '@momentum/i18n';
import { oneOnOneEnTranslations } from './one-on-one.en';

export const oneOnOneHeTranslations = createTranslations(
  oneOnOneEnTranslations,
  {
    // Wizard Progress
    goalsReviewProgress: 'התקדמות סקירת יעדים',
    goalOfTotal: (current: number, total: number) =>
      `יעד ${current} מתוך ${total}`,
    noGoalsToReview: 'אין יעדים לסקירה',
    noGoalsAssigned: 'אין יעדים שהוקצו לך עבור פגישה זו עדיין.',
    meetingProgress: 'התקדמות פגישה',
    goalLabel: 'יעד',
    of: 'מתוך',

    // Navigation Buttons
    previous: 'הקודם',
    next: 'הבא',
    previousGoal: 'יעד קודם',
    nextGoal: 'יעד הבא',
    skip: 'דלג',
    completeReview: 'השלם סקירה',
    backToGoalsReview: 'חזור לסקירת יעדים',
    backToOneOnOnes: 'חזור לפגישות 1:1',

    // Goal Detail Card
    keyResults: 'מדדי ביצוע',
    timeline: 'ציר זמן',
    start: 'התחלה',
    due: 'יעד',
    noDatesSet: 'לא הוגדרו תאריכים עבור יעד זה',
    noKeyResultsDefined: 'לא הוגדרו מדדי ביצוע עבור יעד זה',
    relatedTasks: 'משימות קשורות',
    noTasksAssigned: 'אין משימות שהוקצו לך עבור יעד זה',
    completedOn: ({ date }: { date: string }) => `הושלם ב-${date}`,
    tasksTable: {
      status: 'סטטוס',
      task: 'משימה',
      assignees: 'מוקצים',
      startDate: 'תאריך התחלה',
      dueDate: 'תאריך יעד',
    },

    // Interactions List
    noInteractions: 'טרם נרשמו אינטראקציות עבור יעד זה.',
    previousInteractions: 'אינטראקציות שלך ביעד',
    loggedOn: 'נרשם בתאריך',
    interactionDetailsAvailable: 'פרטי האינטראקציה זמינים',
    viewDetails: 'צפה בפרטים',
    participant: 'משתתף',
    participants: 'משתתפים',
    unknown: 'לא ידוע',
    new: 'חדש',

    // Interaction Types
    iSeeYou: 'אני רואה אותך',
    iNeedYou: 'אני צריך אותך',
    iLearn: 'אני לומד',

    // Interaction Creation Card
    createInteractionForGoal: 'צור אינטראקציה עבור יעד זה',
    createInteractionDescription:
      'הוסף הכרה, משוב, או תעד למידה הקשורה ליעד זה.',
    iSeeYouDescription: 'הכר בעבודה מצוינת וחגוג הישגים',
    iNeedYouDescription: 'שתף משוב בונה לצמיחה',
    iLearnDescription: 'תעד לקחים ותובנות',

    // Interaction Wizard Drawer
    oneOnOneInProgress: 'פגישת 1:1 בתהליך',
    creatingForGoal: 'יוצר עבור יעד',

    // Wizard Stepper
    goalsReview: 'סקירת יעדים',
    summary: 'סיכום',

    // Summary Stage
    oneOnOneSummary: 'סיכום פגישת 1:1',
    completedOneOnOne: 'פגישת 1:1 שהושלמה',
    summaryDescription:
      'סקור את סיכום הפגישה שלך למטה. ניתן לערוך כל קטע או לשלוח כדי להשלים את הפגישה.',
    totalGoals: 'סה״כ יעדים',
    goalsReviewed: 'יעדים שנסקרו',
    status: 'סטטוס',
    complete: 'הושלם',
    reviewedGoals: 'יעדים שנסקרו',
    editGoalsReview: 'ערוך סקירת יעדים',
    readyToSubmit: 'מוכן לשליחה?',
    submitDescription: 'לאחר השליחה, פגישה זו תסומן כהושלמה.',
    submitOneOnOne: 'סיים פגישת 1:1',
    submitting: 'שולח...',
    sentToManager: 'נשלח למנהל',
    waitingForManagerToSubmit: 'ממתין למנהל לסיים את פגישת ה-1:1',
    failedToSaveNotes: 'שמירת ההערות נכשלה. אנא נסה שוב.',
    onlyEmployeeCanCreate: 'רק עובדים יכולים ליצור פגישות 1:1',
    oneOnOneCompleted: 'פגישת 1:1 הושלמה',
    oneOnOneCompletedDescription: 'פגישת ה-1:1 הזו הושלמה ונסיימה',

    // Toast Notifications
    goalsReviewSaved: 'סקירת יעדים נשמרה',
    successfullySavedReview: (count: number) =>
      `נשמרה בהצלחה סקירה של ${count} ${count === 1 ? 'יעד' : 'יעדים'}`,
    failedToSave: 'שמירה נכשלה',
    couldNotSaveReview: 'לא ניתן לשמור את סקירת היעדים. אנא נסה שוב.',
    failedToUpdateStatus: 'עדכון סטטוס נכשל',
    couldNotUpdateGoalStatus: 'לא ניתן לעדכן את סטטוס היעד. אנא נסה שוב.',
    failedToUpdateTaskStatus: 'עדכון סטטוס משימה נכשל',
    couldNotUpdateTaskStatus: 'לא ניתן לעדכן את סטטוס המשימה. אנא נסה שוב.',
    taskStatusUpdated: 'סטטוס משימה עודכן',
    taskStatusUpdatedSuccessfully: 'סטטוס המשימה עודכן בהצלחה.',
    viewTask: 'צפה במשימה',
    relatedSignalsTooltip: (count: number) =>
      count === 1 ? 'סיגנל רלוונטי אחד' : `${count} סיגנלים רלוונטיים`,
    deleteTask: 'מחק משימה',
    deleteTaskTitle: 'מחק משימה',
    deleteTaskDescription: (taskTitle: string) =>
      `האם אתה בטוח שברצונך למחוק את "${taskTitle}"? פעולה זו לא ניתנת לביטול.`,
    deleteTaskConfirm: 'מחק',
    deleteTaskCancel: 'ביטול',
    deleteTaskDeleting: 'מוחק...',
    taskDeleted: 'משימה נמחקה',
    taskDeletedSuccessfully: 'המשימה נמחקה בהצלחה',
    failedToDeleteTask: 'מחיקת משימה נכשלה',
    couldNotDeleteTask: 'לא ניתן למחוק את המשימה. אנא נסה שוב.',

    // Landing Page
    oneOnOne: 'פגישת 1:1',
    prepareDescription:
      'התכונן לפגישות 1:1 שלך עם האשף המקיף שלנו. סקור יעדים, התבונן על התקדמות, ותעד את תוצאות הפגישה.',
    wizardDescription:
      'האשף מדריך אותך דרך סקירת היעדים שהוקצו והאינטראקציות הקשורות אליהן, ולאחר מכן עוזר לך ליצור סיכום של פגישת ה-1:1.',
    startOneOnOneWizard: 'התחל אשף פגישת 1:1',

    // Route Page Headers
    oneOnOneWizard: 'אשף פגישת 1:1',
    prepareForUpcoming: 'התכונן לפגישת 1:1 הקרובה שלך',
    viewCompletedOneOnOne: 'צפה בפגישת 1:1 שהושלמה',
    reviewGoalsDescription:
      'סקור את היעדים שלך, התבונן על התקדמות אחרונה, והשלם את סיכום פגישת ה-1:1 שלך.',
    reviewCompletedDescription:
      'צפה בסיכום של פגישת ה-1:1 שהושלמה, כולל כל היעדים, האינטראקציות והערות הפגישה.',

    // Common
    processing: 'מעבד...',
    goal: 'יעד',
    id: 'מזהה',

    // Summary Stage - New
    openBlockages: 'חסמים פתוחים',
    totalInteractions: 'סה״כ אינטראקציות',
    goalsOnTrack: 'יעדים במסלול',
    goalsAndInteractions: 'יעדים ואינטראקציות',
    reviewYourGoalsAndInteractions: 'סקור את כל היעדים והאינטראקציות הקשורות',
    blockagesCount: (count: number) =>
      count === 1 ? `חסם פתוח ${count}` : `חסמים פתוחים ${count}`,
    interactions: 'אינטראקציות',
    notSet: 'לא הוגדר',
    onTrack: 'במסלול',
    offTrack: 'מחוץ למסלול',
    interactionCount: (count: number) =>
      count === 1 ? `אינטראקציה ${count}` : `אינטראקציות ${count}`,

    // Meeting Notes
    meetingNotes: 'הערות פגישה',
    meetingNotesDescription: 'הוסף הערות ותובנות מפגישת ה-1:1 שלך',
    meetingNotesFromSession: 'הערות מפגישת ה-1:1 שהושלמה',
    noNotesAdded: 'לא נוספו הערות במהלך פגישה זו',
    addNotePlaceholder: 'הקלד את ההערה שלך כאן...',
    pressEnterToAdd: 'לחץ Cmd/Ctrl + Enter להוספה',
    addNote: 'הוסף הערה',
    noteCount: (count: number) =>
      count === 1 ? `הערה ${count} נוספה` : `הערות ${count} נוספו`,
    goalsAndNotes: 'יעדים והערות',
    reviewGoalsAndAddNotes: 'סקור את היעדים שלך והוסף הערות פגישה',

    // Landing Page - One-on-Ones List
    myOneOnOnes: 'פגישות ה-1:1 שלי',
    teamOneOnOnes: 'פגישות 1:1 עם העובדים שלי',
    oneOnOnes: 'פגישות 1:1',
    total: 'סה״כ',
    loading: 'טוען...',
    oneOnOneWith: 'פגישת 1:1 עם',
    notes: 'הערות',
    noOneOnOnesFound: 'לא נמצאו פגישות 1:1',
    scheduled: 'מתוכננת',
    inProgress: 'בתהליך',
    readyForSubmission: 'מוכן לפגישה',
    completed: 'הושלמה',
    locked: 'סיים',
    stagesCompleted: 'שלבים הושלמו',
    startNewOneOnOne: 'התחל פגישת 1:1 חדשה',
    creating: 'יוצר...',
    oneOnOneCreated: 'פגישת 1:1 נוצרה',
    oneOnOneCreatedDescription: 'פגישת ה-1:1 שלך נוצרה בהצלחה',
    oneOnOneCreatedWithEmployee: 'פגישת 1:1 נוצרה בהצלחה עם העובד',
    failedToCreate: 'יצירה נכשלה',
    couldNotCreateOneOnOne: 'לא ניתן ליצור פגישת 1:1. אנא נסה שוב.',
    noManagerAssigned: 'אין מנהל ישיר',
    noManagerDescription: 'נדרש מנהל ישיר כדי להתחיל פגישת 1:1.',
    createOneOnOne: 'צור פגישת 1:1',
    createMeeting: 'צור פגישה',
    createOneOnOneWithEmployee: 'צור פגישת 1:1 עם עובד',
    selectEmployeeForOneOnOne: 'בחר עובד לקביעת פגישת 1:1',
    cancel: 'ביטול',
    create: 'צור',

    // Sidebar
    your1on1Meetings: 'פגישות ה-1:1 שלך',
    myManager: 'פגישות עם המנהל שלי',
    teamSize: 'גודל הצוות',
    directReports: 'כפיפים ישירים',
    yourTeam: 'פגישות עם העובדים שלי',
    sortBy: 'מיין לפי',
    needsAttention: 'דורש תשומת לב',
    hasntHadMeetingIn: (name: string, days: number) =>
      `${name} לא קיים פגישה כבר ${days} ימים`,
    create1on1WithManager: 'צור פגישת 1:1 עם המנהל',

    // Meeting History
    meetingHistory: 'היסטוריית פגישות',
    newMeeting: 'פגישה חדשה',
    totalMeetingSingular: 'פגישה בסך הכל',
    totalMeetingsPlural: 'פגישות בסך הכל',
    totalMeetings: (count: number) =>
      count === 1 ? `פגישה ${count}` : `${count} פגישות`,
    lastMeeting: 'פגישה אחרונה',
    daysAgo: (days: number) =>
      days === 1 ? `לפני ${days} יום` : `לפני ${days} ימים`,
    duration: 'משך',
    minutes: 'דק׳',
    min: 'דק׳',
    discussed: 'נדון',
    selectEmployeeToView: 'בחר עובד כדי לראות את היסטוריית הפגישות שלו',
    never: 'לא קוימה פגישה',
    employee: 'עובד',
    lastMeetingText: 'לפני 3 ימים',
    employeeNeedsAttention: (name: string) =>
      `${name} לא קיים פגישה כבר 28 ימים`,
    seniorDeveloperEngineering: 'מפתח בכיר • הנדסה',
    managerWithEmployee: (firstName: string, lastName: string) =>
      `אתה (מנהל) עם ${firstName} ${lastName}`,
    performanceReview: 'סקירת ביצועים',
    stages: 'שלבים',

    // Coworker 1:1
    create1on1WithCoworker: 'צור פגישת 1:1 עם עמית',
    selectCoworker: 'בחר עמית',
    selectCoworkerDescription: 'בחר עמית לסקירת יעדים יחד בפגישת 1:1',
    noCoworkersAvailable: 'אין עמיתים זמינים',
    noCoworkersAvailableDescription:
      'אין עמיתים זמינים ליצירת פגישת 1:1 בשלב זה.',
    creating1on1WithCoworker: 'יוצר פגישת 1:1...',

    // Professional Meetings
    professionalMeetings: 'פגישות 1:1 עם המנהלים שלי',
    professionalMeetingsFacilitator: 'פגישות 1:1 עם עובדים',
    createProfessionalMeeting: 'צור פגישת 1:1 עם מנהל אחר',

    // Meeting Timeline
    created: 'נוצרה',
    finished: 'הסתיימה',
    at: 'ב',

    // Meeting Titles
    oneOnOneMeetingTitle: 'פגישת 1:1',
    professionalMeetingTitle: 'פגישה מקצועית',

    // Replace Open Meeting Dialog
    replaceOpenMeeting: 'פגישה פתוחה קיימת',
    replaceOpenMeetingDescription: (employeeName: string) =>
      `יש לך כבר פגישה פתוחה עם ${employeeName}. כדי ליצור פגישה חדשה, תצטרך להחליף את הקיימת.`,
    replaceMeeting: 'החלף וצור חדשה',
    replacing: 'מחליף...',
    meetingReplaced: 'פגישה הוחלפה',
    meetingReplacedDescription: 'הפגישה הקיימת הוחלפה ופגישה חדשה נוצרה',
    failedToReplace: 'החלפה נכשלה',
    couldNotReplaceMeeting: 'לא ניתן להחליף את הפגישה. אנא נסה שוב.',
  }
);
